import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      d="M2.96262 18.0041L10.2087 3.52252C11.2247 1.49207 14.1171 1.49261 15.1323 3.52342L22.3719 18.0051C23.2889 19.8397 21.9577 22 19.9099 22H5.42417C3.37586 22 2.04457 19.8389 2.96262 18.0041Z"
      fill="currentColor"
    />
    <path
      d="M12.667 8C13.2193 8 13.667 8.44772 13.667 9V12C13.667 12.5523 13.2193 13 12.667 13C12.1147 13 11.667 12.5523 11.667 12V9C11.667 8.44772 12.1147 8 12.667 8Z"
      fill="#32323B"
    />
    <path
      d="M12.667 17C13.2193 17 13.667 16.5523 13.667 16C13.667 15.4477 13.2193 15 12.667 15C12.1147 15 11.667 15.4477 11.667 16C11.667 16.5523 12.1147 17 12.667 17Z"
      fill="#32323B"
    />
  </SvgIcon>
));
